export default __webpack_public_path__ + "static/assets/images/8f79cdb28a30e961bce8227e86da986c.svg";